import { Component, Input } from '@angular/core';

/** Titulo de seccion: barra roja, texto y linea que se desvanece (.z-section-title). */
@Component({
  selector: 'app-section-title',
  templateUrl: './section-title.component.html',
  styleUrl: './section-title.component.scss',
  standalone: false,
})
export class SectionTitleComponent {
  @Input() public title = '';
}
